import './footer.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faDiscord,
    faFacebookF,
    faInstagram,
    faLinkedinIn,
    faXTwitter,
    faYoutube
} from '@fortawesome/free-brands-svg-icons';

//UTILS
import { isMobile } from 'react-device-detect';

//VISUALS
import LOGO from '../../assets/images/full_white_baseline.png';
import POLYGON from '../../assets/images/polygon-matic-logo.png';

//TRANSLATION
import { useTranslation } from 'react-i18next';

const Footer = () => {
    const currentPath = window.location.pathname;
    const { t, i18n } = useTranslation();

    const handleLangChange = lang => {
        i18n.changeLanguage(lang);
    };

    return ((!isMobile || ["/", "/signin", "/signup"].includes(currentPath)) &&
        <footer>
            <div className="split">
                <img src={LOGO} alt="Lifise logo" className="logo" />
                {i18n.language === "en" ? <span className="selecter" onClick={() => handleLangChange('fr')}>
                    FR
                </span>
                    :
                    <span className="selecter" onClick={() => handleLangChange('en')}>
                        EN
                    </span>}
                <span className="selecter" onClick={() => window.open("https://www.lifise.io/fr/mentions-legales")}>{t('footer.cgu')}</span>
                <span className="selecter" onClick={() => window.open("https://www.lifise.io/fr/politique-de-confidentialite")}>{t('footer.policy')}</span>
                <span className="selecter" onClick={() => window.open(
                    i18n.language === "fr" ?
                        "https://livreblanc.lifise.io/"
                        :
                        "https://whitepaper.lifise.io/")}>{t('footer.whitepaper')}</span>
            </div>
            <div className="split">
                <h4>
                    {t('footer.editor')}
                </h4>
                <p>
                    {t('footer.publisher')}
                    <br />
                    {t('footer.vat_number')}
                </p>
                <p>
                    Email : <strong><a href={"mailTo:contact@lifise.io"}>contact@lifise.io</a></strong>
                    <br />
                    {t('footer.publising_director')}
                </p>
            </div>
            <div className="split">
                <h4>
                    {t('footer.legals')}
                </h4>
                <p>
                    En Liens! Rovaltain Web Société {t('footer.joint_company')} 88900€
                </p>
                <p>
                    {t('footer.head_office')} : 16 Cours Alexandre Borodine
                    <br />
                    26000 VALENCE 914 291 372 RCS ROMANS - {t('footer.tva')} : FR84914291372
                </p>
            </div>

            <div className="split">
                <h4>
                    {t('footer.follow_us')}
                </h4>
                <FontAwesomeIcon icon={faLinkedinIn} className="social" title="LinkedIn" onClick={() => window.open("https://www.linkedin.com/company/80497650")} />
                <FontAwesomeIcon icon={faXTwitter} className="social" title="X" onClick={() => window.open("https://x.com/LiFiSe_Finance")} />
                <FontAwesomeIcon icon={faYoutube} className="social" title="YouTube" onClick={() => window.open("https://www.youtube.com/channel/UCscHwitaskD9i8IT_r3YVCA")} />
                <FontAwesomeIcon icon={faFacebookF} className="social" title="Facebook" onClick={() => window.open("https://www.facebook.com/teamlifise")} />
                <FontAwesomeIcon icon={faInstagram} className="social" title="Instagram" onClick={() => window.open("https://www.instagram.com/lifise_finance_officiel/")} />
                <FontAwesomeIcon icon={faDiscord} className="social" title="Discord" onClick={() => window.open("https://discord.gg/lifise")} />
            </div>

            <div className="footer_legal_band">
                <div className="legal_head">
                    <img src={POLYGON} alt="Polygon" className="legal_chain" />
                    <h4>{t('footer.smart_contract')}</h4>
                </div>
                <div className="legal_grid">
                    <div className="legal_item">
                        <span className="legal_label">{t('footer.lei_label')}</span>
                        <span className="legal_value">969500IP4HST8BLLCF66</span>
                        <span className="legal_note">{t('footer.lei_attributed')}</span>
                    </div>
                    <div className="legal_item">
                        <span className="legal_label">{t('footer.dti_title')}</span>
                        <span className="legal_value">{t('footer.dti_token')} : ZJM19RHBC</span>
                        <span className="legal_value">{t('footer.dti_issuer')} : LS54M4GSV</span>
                        <span className="legal_note">{t('footer.dti_obtained')}</span>
                    </div>
                    <div className="legal_item">
                        <span className="legal_label">{t('footer.contract_address')}</span>
                        <span className="legal_value legal_link" onClick={() => window.open("https://polygonscan.com/address/0xed3004e8b62cf241a2fe4B2347Ca316ef15F539e")}>
                            0xed30…F539e
                        </span>
                        <span className="legal_note">Polygon (PoS)</span>
                    </div>
                </div>
            </div>
        </footer>
    )
};

export default Footer;
